import { EnvironmentInjector } from '@angular/core';

export class AppInjector {
  private static injector: EnvironmentInjector;

  static set(injector: EnvironmentInjector): void {
    AppInjector.injector = injector;
  }

  static get(): EnvironmentInjector {
    if (!AppInjector.injector) {
      throw new Error('Injector has not been set yet.');
    }

    return AppInjector.injector;
  }
}
